import Vue, { DirectiveOptions} from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import '@/permission';
import '@/styles/index.scss';
import i18n from './lang';
import '@/useAntDesign';
import * as directives from '@/directives';
import Card from '@/components/card/index.vue';
import Icon from '@/components/icon.vue';
import Avatar from '@/components/avatar/avatar.vue';
import LangSelect from '@/components/langSelect/index.vue';
import {winNotification} from '@/utils/winNotification';

Vue.config.productionTip = false;

// Register global directives
Object.keys(directives).forEach((key) => {
  Vue.directive(key, (directives as { [key: string ]: DirectiveOptions })[key]);
});

Vue.component('card', Card);
Vue.component('icon', Icon);
Vue.component('avatar', Avatar);
Vue.component('lang-select', LangSelect);
Vue.prototype.$winNotification = winNotification;

winNotification.requestNotificationPermission();

new Vue({
  router,
  store,
  i18n,
  render: (h) => h(App),
}).$mount('#app');
